export default {
  loginUrl: 'auth/login',
  logoutUrl: 'auth/logout',
  registerUrl: 'auth/register',
  refreshUrl: 'auth/token/refresh'
}
